import { useEffect, useState } from "react";
import moment from 'moment';
import { t } from "i18next";
import eventsIcon from "../../assets/images/events.svg";
import eventGreenIcon from "../../assets/images/event-green.svg";
import { Link, useNavigate } from "react-router-dom";
import { getCompetitions } from "../../services/competition";
import { Competition } from "../../interfaces/competition";
import 'moment/locale/es';
import { LoadingSpinner } from "../general/loading-spinner";
import competitionIcon from "../../assets/images/competition.svg";

export function CompetitionsBlock() {
    const navigate = useNavigate();
    moment.locale('es');

    const [competitions, setCompetitions] = useState<any[]>([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getCompetitions()
            .then(response => {
                setCompetitions(response.data);
                setLoaded(true);
            })
            .catch(error => {
                alert('connection_expired');
                localStorage.removeItem('token');
                navigate("/");
                console.log(error);
            });
    }, []);

    return (
        <div className="block block-competition">
            <div className="block-inner">
                <h3 className="block-title">
                    <img src={ eventsIcon } alt={ t("upcoming_events")} />
                    { t("upcoming_events") }
                </h3>
                <div className="block-content">
                    { !loaded && 
                        <LoadingSpinner />
                    }
                    { loaded &&
                        competitions.map((c: Competition) => {
                            return <div key={ 'competition-' + c.id } className="competition-tile">
                                    <div className="icon">
                                        <img src={ eventGreenIcon } />
                                    </div>
                                    <div className="title">
                                        <Link to={ '/competitions/' + c.id + '/view' }  title={ c.name }>
                                            { c.name }
                                        </Link>
                                    </div>
                                    <div className="date_start">
                                        { moment(c.date_start).format('D MMMM') }
                                    </div>
                                </div>
                        })
                    }
                </div>
                <div className="block-footer">
                    <Link to="/competitions-events" title={ t("competitions") } className="btn btn-primary">
                        <img src={ competitionIcon } alt={ t("competitions")} /> { t("competitions") }
                    </Link>
                </div>
            </div>
        </div>
    );
}  
